import { render } from "./MarketingNotificationAllDatatableActions.vue?vue&type=template&id=36900c18"
import script from "./MarketingNotificationAllDatatableActions.vue?vue&type=script&lang=js"
export * from "./MarketingNotificationAllDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__